import { ProductFM } from '@bm-js/atlascloud-shared'
import { Button, CText, ResponsiveImage } from '@bm-js/atlascloud-ui'
import { Card, CardBody } from '@heroui/card'

type Props = {
  product: ProductFM
  editProduct: (product: ProductFM) => void
  deleteProduct: (product: ProductFM) => void
}

const ProductCard = ({ product, editProduct, deleteProduct }: Props) => {
  return (
    <Card>
      <CardBody>
        <div className='flex items-center gap-2'>
          <ResponsiveImage
            file={product.images[0]}
            className='w-20 h-20 object-cover rounded-lg border border-gray-200 mr-4'
          />
          <CText className='text-lg font-bold'>{product.title}</CText>
          <CText className=''>{product.priceSEK} kr</CText>
          <div className='flex self-start items-start gap-2 ml-auto'>
            <Button onClick={() => editProduct(product)}>Redigera</Button>
            <Button danger onClick={() => deleteProduct(product)}>
              Radera
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

export default ProductCard
